var React = require('react');

function IconTablet (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M18.5 0h-14A2.5 2.5 0 0 0 2 2.5v19A2.5 2.5 0 0 0 4.5 24h14a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 18.5 0zm-7 23a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm7.5-4H4V3h15z","key":1})]);
}

IconTablet.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconTablet;

IconTablet.default = IconTablet;
